import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { ShopProvider } from "@/context/ShopContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileNav from "@/components/layout/MobileNav";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import MartPage from "@/pages/MartPage";
import ProductPage from "@/pages/ProductPage";
import NewArrivals from "@/pages/NewArrivals";
import Offers from "@/pages/Offers";
import Brands from "@/pages/Brands";
import { Stores, StorePage } from "@/pages/Stores";
import { Vendors, VendorPage } from "@/pages/Vendors";
import { Blog, BlogPost } from "@/pages/Blog";
import About from "@/pages/About";
import Legal from "@/pages/Legal";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Wishlist from "@/pages/Wishlist";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import VendorPortal from "@/pages/VendorPortal";
import VendorOnboard from "@/pages/VendorOnboard";
import AccountLayout from "@/pages/account/AccountLayout";
import Profile from "@/pages/account/Profile";
import Orders from "@/pages/account/Orders";
import Addresses from "@/pages/account/Addresses";
import Customizations from "@/pages/account/Customizations";
import { BecomeVendor, FurnitureVendor, Franchise, Corporate, Contact } from "@/pages/Business";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppInner() {
  const location = useLocation();
  // Emergent OAuth callback: process session_id before anything else
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <ScrollToTop />
      <Header />
      <main className="pb-16 lg:pb-0 min-h-[50vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/home-mart" element={<MartPage slug="home-mart" />} />
          <Route path="/style-mart" element={<MartPage slug="style-mart" />} />
          <Route path="/wood-mart" element={<MartPage slug="wood-mart" />} />
          <Route path="/tech-mart" element={<MartPage slug="tech-mart" />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/new-arrivals" element={<NewArrivals />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/stores" element={<Stores />} />
          <Route path="/stores/:slug" element={<StorePage />} />
          <Route path="/vendors" element={<Vendors />} />
          <Route path="/vendors/:id" element={<VendorPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/become-vendor" element={<BecomeVendor />} />
          <Route path="/furniture-vendor" element={<FurnitureVendor />} />
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/vendor" element={<VendorPortal />} />
          <Route path="/vendor/onboard/:token" element={<VendorOnboard />} />
          <Route path="/account" element={<AccountLayout />}>
            <Route index element={<Profile />} />
            <Route path="orders" element={<Orders />} />
            <Route path="addresses" element={<Addresses />} />
            <Route path="customizations" element={<Customizations />} />
          </Route>
        </Routes>
      </main>
      <Footer />
      <MobileNav />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ShopProvider>
            <AppInner />
          </ShopProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
